import { Drawer } from "@material-ui/core";
import { Box, Grid, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ChatCard from "./chatCard";

import AttachmentIcon from "@mui/icons-material/Attachment";
import QuestionAnswerOutlinedIcon from "@mui/icons-material/QuestionAnswerOutlined";
import ReplayIcon from "@mui/icons-material/Replay";
import SendIcon from "@mui/icons-material/Send";
import { useMutation } from "react-query";
import AttachmentDrawer from "../../components/drawers/attachmentDrawer";
// import CircleIcon from "@mui/icons-material/Circle";
import Brightness1Icon from "@mui/icons-material/Brightness1";

import { useHistory } from "react-router-dom";

import { v4 } from "uuid";

import { useDispatch } from "react-redux";
import {
  GetLoanCommentsChangesResponse,
  GetLoanCommentsResponse,
  GetUsersReponse,
  SendMessageRequest,
} from "../../models/chat.model";
import { seenNotification } from "../../redux/comments/commentSlice";
import {
  ConfirmHasTheUserSeen,
  GetLoanCommentsChanges,
  SendMessage,
} from "../../services/chat.service";
import ChatCardSkeleton from "./chatCardSkeleton";
import CommentInput from "./commentInput";

const commentsPaperStyle = `
.MuiDrawer-paper{
  background:#273C51 !important;
  overflow-x: hidden;
}
`;

interface props {
  referenceKey: string | undefined;
  commentsLoading: boolean;
  fetchDate: any;
  setFetchDate: any;
  setMessages: any;
  messages: GetLoanCommentsResponse[];
  setAllMessages: any;
  setLastMessageKey: any;
  allMessages: GetLoanCommentsResponse[];
  lastMessageKey: string;
  isReloadBtnDisable: boolean;
  setReloadBtnDisable: any;
  moveToEnd?: string;
}

const CommentSideMenu = ({
  referenceKey,
  commentsLoading,
  fetchDate,
  setAllMessages,
  setFetchDate,
  setLastMessageKey,
  setMessages,
  messages,
  allMessages,
  lastMessageKey,
  isReloadBtnDisable,
  setReloadBtnDisable,
  moveToEnd,
}: props) => {
  const [openDrawer, setOpenDrawer] = useState(false);

  const [attachmentDrawer, setAttachmentDrawer] = useState(false);
  const [comment, setComment] = useState("");

  const [messagesChange, setMessagesChange] = useState<
    GetLoanCommentsChangesResponse
  >();

  const [files, setFiles] = useState<any>();
  const scrollToBottom = useRef<HTMLDivElement>(null);

  const [refreshOnDel, setRefreshOnDel] = useState<string>("");
  const [refreshOnSendCap, setRefreshOnSendCap] = useState<string>("");

  const [enableFetchNotification, setEnableFetchNotification] = useState(true);
  const [isTyping, setTyping] = useState(false);

  const dispatch = useDispatch();

  const mentionPattern = /\@(.*?)\)/gi;

  const cardSleletonNum = 10;

  const { mutate: GetLoanCommentsChangesMutate } = useMutation(
    GetLoanCommentsChanges,
    {
      onSuccess: (data: GetLoanCommentsChangesResponse) => {
        if (data) {
          setTimeout(() => setReloadBtnDisable(false), 2 * 60 * 1000);
          let MyDate = new Date();
          let Day = new Date().toLocaleDateString("fa-IR");
          let Hours;
          let Minutes;
          let Sec;

          MyDate.getSeconds() < 10
            ? (Sec = "0" + MyDate.getSeconds().toString())
            : (Sec = MyDate.getSeconds().toString());
          MyDate.getMinutes() < 10
            ? (Minutes = "0" + MyDate.getMinutes().toString())
            : (Minutes = MyDate.getMinutes().toString());
          MyDate.getHours() < 10
            ? (Hours = "0" + MyDate.getHours().toString())
            : (Hours = MyDate.getHours().toString());

          setFetchDate(Day + " - " + Hours + ": " + Minutes + ": " + Sec);

          setMessagesChange(data);
          setLastMessageKey(
            data.loanComments[data.loanComments.length - 1].key
          );

          setAllMessages([...allMessages, ...data.loanComments]);

          var filteredMassages = allMessages.filter(
            (itemX) => !data.deletedMessageKeys.includes(itemX.key)
          );

          setAllMessages([...filteredMassages, ...data?.loanComments]);

          setTimeout(() => {
            moveToBottom();
          }, 100);
        }
      },
      onError: () => {
        setTimeout(() => {
          moveToBottom();
        }, 100);
      },
    }
  );

  useEffect(() => {
    if (
      messagesChange?.deletedMessageKeys &&
      messagesChange?.deletedMessageKeys.length > 0
    ) {
      var filteredMassages = allMessages.filter(
        (itemX) => !messagesChange.deletedMessageKeys.includes(itemX.key)
      );

      setAllMessages([...filteredMassages, ...messagesChange?.loanComments]);
    }
  }, [messagesChange?.deletedMessageKeys]);

  const { mutate: SendMessageMutation } = useMutation(SendMessage, {
    onSuccess: (data: boolean) => {
      GetLoanCommentsChangesMutate({
        referenceKey: referenceKey!,
        fromChatKey: lastMessageKey !== "" ? lastMessageKey : null,
      });
      setTimeout(() => {
        moveToBottom();
      }, 300);
    },
    onError: () => {},
  });

  const MINUTE_MS = 5 * 60 * 1000;
  useEffect(() => {
    const interval = setInterval(() => {
      if (referenceKey !== undefined) {
        GetLoanCommentsChangesMutate({
          referenceKey: referenceKey!,
          fromChatKey: lastMessageKey !== "" ? lastMessageKey : null,
        });
      }
    }, MINUTE_MS);

    return () => clearInterval(interval);
  }, [lastMessageKey]);

  useEffect(() => {
    if (referenceKey !== undefined) {
      if (refreshOnSendCap !== "") {
        GetLoanCommentsChangesMutate({
          referenceKey: referenceKey!,
          fromChatKey: lastMessageKey !== "" ? lastMessageKey : null,
        });
      }
    }
  }, [refreshOnSendCap]);

  useEffect(() => {
    if (referenceKey !== undefined) {
      if (refreshOnDel !== "") {
        GetLoanCommentsChangesMutate({
          referenceKey: referenceKey!,
          fromChatKey: lastMessageKey !== "" ? lastMessageKey : null,
        });
      }
    }
  }, [refreshOnDel]);

  const moveToBottom = () => {
    if (scrollToBottom.current) {
      // scrollToBottom.current.scrollIntoView({
      //   behavior: "smooth",
      // });
      scrollToBottom.current.scrollIntoView();
    }
  };

  useEffect(() => {
    setTimeout(() => {
      moveToBottom();
    }, 500);
  }, [moveToEnd]);

  const handleSendMessage = () => {
    if (comment.trim() !== "") {
      const newMessage = {} as SendMessageRequest;

      if (mentionPattern.test(comment)) {
        let desiredText = comment.replace(mentionPattern, "");
        let mentionedIds;
        let mentioned: any = [];
        const mentionedSet = new Set();
        let mentionedUserIds: any = [];

        while ((mentionedIds = mentionPattern.exec(comment)) !== null) {
          mentioned.push(mentionedIds[0]);
        }

        mentioned.map((item: any) => {
          mentionedSet.add(Number(item.split("(")[1].split("/")[0]));
        });

        mentionedSet.forEach((value, valueAgain, set) => {
          mentionedUserIds.push(value);
        });
        if (mentionedUserIds) {
          newMessage.mentionedUserIds = mentionedUserIds;
        }

        if (desiredText === "") {
          desiredText = " ";
        }
        newMessage.messageText = desiredText;
      } else {
        newMessage.messageText = comment;
      }

      newMessage.referrerMessageKey = "";
      newMessage.referenceKey = referenceKey!;

      newMessage.files = files;
      SendMessageMutation(newMessage);
      setComment("");
      setTyping(false);
      setReloadBtnDisable(true);
    }
  };

  const { mutate: UserSeenMutation } = useMutation(ConfirmHasTheUserSeen, {
    onSuccess: (data: boolean) => {
      if (data) {
        setEnableFetchNotification(false);
        setTimeout(() => {
          setEnableFetchNotification(true);
        }, 60000);

        dispatch(
          seenNotification({
            hasSeened: v4(),
          })
        );
      }
    },
    onError: () => {},
  });

  const users: GetUsersReponse[] | undefined = JSON.parse(
    localStorage.getItem("getMentionusers")!
  );

  const mentionUsers: any = users?.map((user: GetUsersReponse) => ({
    id: user.id + "/" + user.genderType,
    display:
      user.firstName || user.lastName !== null
        ? user.firstName + " " + user.lastName
        : user.username,
  }));

  const history = useHistory<any>();

  let drawerState =
    history.location.state !== undefined
      ? history.location.state.openChatDrawer
      : null;

  useEffect(() => {
    setOpenDrawer(drawerState);
  }, [drawerState]);

  return (
    <>
      <style>{commentsPaperStyle}</style>
      <Tooltip title="گفتگو های پرونده">
        <div
          onClick={() => {
            enableFetchNotification &&
              UserSeenMutation({ referenceKey: referenceKey! });
            setOpenDrawer(true);
            setTimeout(() => {
              moveToBottom();
            }, 100);
          }}
          className="cursorPointer chat-anchor"
        >
          {allMessages?.length !== 0 ? (
            <p
              style={{ rotate: "-90deg", color: "#fff", whiteSpace: "nowrap" }}
            >
              <Brightness1Icon
                style={{
                  margin: "8px",
                  color: "#28A745",
                  fontSize: "8px",
                  border: "none",
                }}
                className="glowing"
              />
              گفتگو های پرونده
            </p>
          ) : (
            <p
              style={{ rotate: "-90deg", color: "#fff", whiteSpace: "nowrap" }}
            >
              <QuestionAnswerOutlinedIcon
                style={{
                  margin: "5px",
                  color: "#FFF",
                  fontSize: "17px",
                  border: "none",
                }}
              />
              گفتگو های پرونده
            </p>
          )}
        </div>
      </Tooltip>
      <Drawer
        open={openDrawer}
        onClose={() => {
          setOpenDrawer(false);
          setAttachmentDrawer(false);
        }}
        anchor="right"
        style={{ zIndex: "100", overscrollBehavior: "contain" }}
      >
        <div className="commentSide-update">
          <Grid
            container
            justifyContent={"space-between"}
            alignItems={"center"}
            padding={"20px 15px"}
          >
            <Grid item>
              <Typography color={"#18FFFF"} fontSize={"13px"}>
                آخرین بروزرسانی:
              </Typography>
            </Grid>
            <Grid item>
              <Grid container>
                {isReloadBtnDisable === false ? (
                  <Grid
                    sx={{ cursor: "pointer", marginLeft: "10px" }}
                    item
                    onClick={() => {
                      GetLoanCommentsChangesMutate({
                        referenceKey: referenceKey!,
                        fromChatKey: lastMessageKey,
                      });
                      setReloadBtnDisable(true);
                    }}
                  >
                    <ReplayIcon
                      sx={{
                        color: "#18FFFF",
                        fontSize: "17px",
                        transform: "scaleX(-1) rotate(-50deg)",
                      }}
                    />
                  </Grid>
                ) : null}
                <Grid
                  item
                  color={"#18FFFF"}
                  fontSize={"13px"}
                  sx={{ direction: "ltr" }}
                >
                  {fetchDate}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>

        {!commentsLoading ? (
          allMessages?.length !== 0 ? (
            <div className="cards-container">
              {allMessages?.map((message: any, index: number) => (
                <>
                  {message.messageText !== null ||
                  message.receivers.length > 0 ||
                  message.files.length > 0 ? (
                    <ChatCard
                      chatBorder={message.isSender ? "reciver" : "sender"}
                      avatarGender={message.creatorPersonInfo.genderType}
                      message={message.messageText}
                      date={message.createDatePersian}
                      files={message.files}
                      referenceKey={referenceKey!}
                      userTitle={message.creatorPersonInfo.fullName}
                      messageKey={message.key}
                      isSender={message.isSender}
                      canBeDeleted={message.canBeDeleted}
                      refMessageKey={message.referrerMessageKey}
                      mentionUsers={mentionUsers}
                      setRefreshOnDel={setRefreshOnDel}
                      receivers={message.receivers}
                      repliedMessage={message.parentLoanComment}
                      setRefreshOnSendCap={setRefreshOnSendCap}
                    />
                  ) : null}
                </>
              ))}
              <div style={{ height: "50px" }}></div>
            </div>
          ) : (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid
                container
                direction={"column"}
                justifyContent={"center"}
                alignItems={"center"}
                gap={"10px"}
              >
                <Grid item>
                  <QuestionAnswerOutlinedIcon
                    sx={{ color: "#fff", fontSize: "40px" }}
                  />
                </Grid>
                <Grid item>
                  <Typography fontSize={"12px"} color={"#fff"}>
                    پیگیری برای این پرونده انجام نشده است !
                  </Typography>
                </Grid>
              </Grid>
            </div>
          )
        ) : (
          <>
            {[...Array(cardSleletonNum)].map((e, i) => (
              <>
                <div>
                  <ChatCardSkeleton key={i} />
                </div>
                <br />
              </>
            ))}
          </>
        )}
        <div ref={scrollToBottom} />

        <Box
          style={{
            background: "#fff",
            width: "75%",
            // height: "50px",
            margin: "0px 2px 0px 15px",
            position: "fixed",
            bottom: 0,
            left: 0,
            zIndex: 1000,
            borderCollapse: "separate",
            borderRadius: "5px",
            maxWidth: "440px",
          }}
        >
          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <CommentInput
              mentionUsers={mentionUsers}
              comment={comment}
              setComment={setComment}
              setTyping={setTyping}
              isTyping={isTyping}
            />
            {!isTyping && (
              <Grid
                item
                xs={1}
                width={"100%"}
                height={"100%"}
                sx={{ cursor: "pointer" }}
                onClick={() => setAttachmentDrawer(true)}
              >
                <AttachmentIcon fontSize="large" />
              </Grid>
            )}

            <Grid
              item
              xs={1}
              width={"100%"}
              height={"100%"}
              sx={{ cursor: "pointer" }}
              onClick={handleSendMessage}
            >
              <SendIcon style={{ rotate: "180deg" }} fontSize="large" />
            </Grid>
            {/* <Grid item xs={2}></Grid> */}
          </Grid>
        </Box>
        <AttachmentDrawer
          attachmentDrawer={attachmentDrawer}
          setAttachmentDrawer={setAttachmentDrawer}
          referenceKey={referenceKey!}
          mentionUsers={mentionUsers}
          setRefreshOnSendCap={setRefreshOnSendCap}
        />
      </Drawer>
    </>
  );
};

export default CommentSideMenu;
